import MuiFormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import styled from 'styled-components';

const StyledFormControlLabel = styled(MuiFormControlLabel)`
  width: 100%;
  & .MuiTypography-root {
    ${props => props.theme.typography.body2};
  }
`;

export default function FormControlLabel(props: FormControlLabelProps) {
  return <StyledFormControlLabel {...props}></StyledFormControlLabel>;
}
